import { t, type StringKey } from '@bms2/shared';

/**
 * The accessible name of a remove control, naming what it removes (T679): the
 * word for the action, then the thing. 🔨 The one place this sentence is put
 * together; a caller passes the string key it already owns and, where it reads
 * better, a joiner such as `': '`.
 */
export function removeLabel(key: StringKey, name: string, joiner = ' '): string {
  return `${t(key)}${joiner}${name}`;
}
